import Mustache from 'mustache';



export const renderTemplate = async (templatePath: string, data: Record<string, any>): Promise<string> => {
    // Fetch the template content
    try {
        const templateContent = await fetch(`/templates/${templatePath}`);
        if (!templateContent.ok) {
            throw new Error(`Failed to fetch template: ${templatePath}`);
        }
        const template = await templateContent.text();
        
        return Mustache.render(template, data);  
    }   catch (error) {
        console.error(`Error rendering template from ${templatePath}:`, error);

        return '';  
    }
    }